import { useMutation } from "@apollo/client";
import { Success } from "@towersystems/roam-common/lib/generated-types";
import { UPLOAD_IMAGES_TO_RETAILER } from "../../../../../../utilities/photo-image/constants";
import { useFlashMessages } from "@towersystems/roam-common-native";
import { useNavigation } from "@react-navigation/native";
import { useState } from "react";

type SentToRetailerArgs = {
  productId: string;
  imageIds: string[];
};

export interface SendProgress {
  completed: number;
  total: number;
}

export const useSendToRetailer = () => {
  const { showMessage } = useFlashMessages();
  const navigation = useNavigation<any>();
  const [sendProgress, setSendProgress] = useState<SendProgress | null>(null);

  const [uploadImagesToRetailerByImageId] = useMutation<{
    uploadImagesToRetailerByImageId: Success;
  }>(UPLOAD_IMAGES_TO_RETAILER);

  async function handleSendToRetailer({
    productId,
    imageIds,
  }: SentToRetailerArgs) {
    const succeeded: string[] = [];
    const failed: string[] = [];

    setSendProgress({ completed: 0, total: imageIds.length });

    for (const imageId of imageIds) {
      try {
        const res = await uploadImagesToRetailerByImageId({
          variables: { productId, imageIds: [imageId] },
        });
        if (res.data?.uploadImagesToRetailerByImageId.success) {
          succeeded.push(imageId);
        } else {
          failed.push(imageId);
        }
      } catch {
        failed.push(imageId);
      }
      setSendProgress({ completed: succeeded.length + failed.length, total: imageIds.length });
    }

    setSendProgress(null);

    if (succeeded.length > 0) {
      navigation.navigate("ImagesSentSuccessScreen", { imageIds: succeeded });
    } else {
      showMessage({
        severity: "error",
        message: "Error sending images to retailer",
      });
    }

    if (failed.length > 0 && succeeded.length > 0) {
      showMessage({
        severity: "error",
        message: `${failed.length} image${failed.length === 1 ? "" : "s"} failed to send`,
      });
    }
  }

  const loading = sendProgress !== null;

  return { handleSendToRetailer, sendProgress, loading };
};
